import React, { Fragment } from 'react';
import classnames from 'classnames';

import gridsList from './constants/gridsList';
import GridDisplayer from './GridDisplayer/GridDisplayer';

import styles from './Grids.css';

/*
  Presentational component for Grids
*/

const renderBreakpoints = breakpoints => (
  breakpoints.map((breakpoint, i) => <p key={`breakpoint-${i}`}>{breakpoint}</p>)
);

const Grids = () => (
  <Fragment>
    {gridsList.map(grid => (
      <section key={`grid-${grid.name}`}>
        <article className={styles.gridSection}>
          <h2 className="page-subtitle">{grid.name}</h2>

          <div className="copy-content">
            <p>{grid.description}</p>
          </div>

          <div className={styles.breakpointsList}>
            { renderBreakpoints(grid.breakpoints) }
          </div>

          <div className={classnames(styles.gridList, 'flex flex-justify-between flex-wrap')}>
            { grid.items.map((grid, i) => (
              <GridDisplayer key={`grid-displayer-${i}`} {...grid} />
            ))}
          </div>
        </article>
      </section>
    ))}
  </Fragment> 
);

Grids.displayName = 'Grids';

export default Grids;



// WEBPACK FOOTER //
// ./src/containers/foundations/Grids/Grids.js